// Pass 76 — the ONE canonical student progress/skills route is `/me/progress` (the `/me/*` personal-route
// convention). This builder is the single source of progress links; `/my-skills` is a legacy alias that
// redirects to `/me/progress` (preserving sport/skill query). The modern review-derived reader (MySkillsPage)
// is what mounts there. (Function name kept as buildMySkillsPath for now; Pass 78 owns the My Skills rename.)
export const CANONICAL_STUDENT_PROGRESS_PATH = '/me/progress';

export function buildMySkillsPath({ sport = '', skill = '' } = {}) {
  const params = new URLSearchParams();

  if (sport) {
    params.set('sport', sport);
  }

  if (skill) {
    params.set('skill', skill);
  }

  const query = params.toString();
  return query ? `${CANONICAL_STUDENT_PROGRESS_PATH}?${query}` : CANONICAL_STUDENT_PROGRESS_PATH;
}
